import { CommissionStatuses } from 'constants/commissionStatuses';

import { useRecordContext } from 'react-admin';
import { ChipFieldProps } from 'shared/react-admin/Fields';

import {
  ChipFieldStyled,
  ChipFieldWrapperStyled,
  StatusIconStyled,
} from './CommissionStatusChipField.styled';

export type CommissionStatusChipFieldProps = Omit<ChipFieldProps, 'sx'>;

export const CommissionStatusChipField: React.FC<CommissionStatusChipFieldProps> = ({
  children,
  ...restProps
}) => {
  const record = useRecordContext();

  return (
    <ChipFieldWrapperStyled>
      <ChipFieldStyled
        icon={<StatusIconStyled status={record?.value as CommissionStatuses} />}
        {...restProps}
      />
      {children}
    </ChipFieldWrapperStyled>
  );
};
